import DotsNav from '@modules/common/components/embla-carousel/dots-nav';

type DotsNavBarProps = {
  count: number;
  currentIndex: number;
};

export const DotsNavBar = ({ count, currentIndex }: DotsNavBarProps) => {
  if (count <= 1) {
    return null;
  }
  return (
    <>
      <div aria-atomic="true" aria-live="polite" className="sr-only">
        {`Slide ${currentIndex + 1} of ${count}`}
      </div>
      <div className="flex items-center">
        <DotsNav selectedIndex={currentIndex} snapCount={count} />
      </div>
    </>
  );
};
